import Heading from "../ui/Heading";
import Tabs from "../ui/Tabs/Tabs";

export default function TabbedContent({ data }) {
  const { contentBlock, tab } = data;

  return (
    <section
      className="ob-content-block ob-with-padding"
      style={{ backgroundColor: "#f6f6f6" }}
    >
      <div className="ob-columnar">
        <Heading params={contentBlock} />
      </div>

      <Tabs tab={tab} />
    </section>
  );
}
